import { FeatureFlagService } from '../services/feature-flag.service';

export function featureFlagInitializerFactory(
  featureFlagService: FeatureFlagService
): () => Promise<void> {
  return () => featureFlagService.initializeContext();
}
